/** @jsxImportSource @emotion/react */
import { Tag } from "primereact/tag";

// Pasos de actividad para las tablas del home (actividades abiertas y sin
// decisor): campos planos para buscar, filtrar, ordenar y exportar con
// TablaFiltrable.
export function filasDePasos(pasos) {
  return (pasos || []).map((paso) => {
    const cliente = paso.actividad.proceso.cliente;
    const decisores =
      paso.actividadpaso_x_auditor?.map((a) => `${a.auditor.nombre} ${a.auditor.apellido}`) || [];
    return {
      ...paso,
      _cliente:
        cliente?.nombrefantasia && cliente.nombrefantasia !== cliente.razonsocial
          ? `${cliente.razonsocial} (${cliente.nombrefantasia})`
          : cliente?.razonsocial || "",
      _proceso: `${paso.actividad.proceso.nombre} - ${paso.actividad.proceso.nombrefantasia}`,
      _actividad: paso.actividad.actividadtipo.nombre,
      _paso: paso.nombre,
      _certificadoTipo: paso.actividad.proceso.certificadotipo?.nombre || "",
      _decisores: decisores,
      // Para ordenar por la columna
      _decisoresTexto: decisores.join(", "),
      _diasEnPaso: paso.fechaInicioPaso
        ? Math.floor((Date.now() - new Date(paso.fechaInicioPaso).getTime()) / 86400000)
        : null
    };
  });
}

// Búsqueda y desplegables de la tabla (los de decisores, solo si se muestran)
export const CAMPOS_BUSQUEDA = ["_cliente", "_proceso", "_actividad", "_paso", "_certificadoTipo", "_decisores"];

export function filtrosDePasos(conDecisores) {
  return [
    { campo: "_cliente", label: "Cliente", labelPlural: "clientes" },
    { campo: "_actividad", label: "Actividad", labelPlural: "actividades" },
    { campo: "_paso", label: "Paso", labelPlural: "pasos" },
    { campo: "_certificadoTipo", label: "Tipo de certificado", labelPlural: "tipos" },
    ...(conDecisores ? [{ campo: "_decisores", label: "Decisores", labelPlural: "decisores", multiple: true }] : [])
  ];
}

// Días en el paso actual: verde hasta 1, ámbar hasta 3, rojo después
export function diasEnPasoBody(fila) {
  const d = fila._diasEnPaso;
  if (d === null || d === undefined) return <span css={{ color: "#9e9e9e" }}>—</span>;
  return <Tag severity={d <= 1 ? "success" : d <= 3 ? "warning" : "danger"} value={`${d} ${d === 1 ? "día" : "días"}`} />;
}

// Cada fila lleva a la actividad (con Ctrl/Cmd, en otra pestaña)
export function abrirActividad(navigate) {
  return (e) => {
    const url = `/proceso/${e.data.actividad.proceso.id}/actividades/${e.data.actividad.id}`;
    e.originalEvent.metaKey || e.originalEvent.ctrlKey ? window.open(url, "_blank") : navigate(url);
  };
}
